<template>
  <b-navbar toggleable="lg" type="light" variant="light" fixed="top" sticky>
    <b-container fluid="lg">
      <!-- Brand -->
      <b-navbar-brand to="/">
        <b-img src="@/assets/cpgeo.png" to="/"></b-img>
        <!-- <img src="@/assets/cpgeo.png" /> -->
      </b-navbar-brand>
      <!-- Toggler -->
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <!-- Collapsable navbar -->
      <b-collapse id="nav-collapse" is-nav>
        <!-- Navbar nav items left aligned -->
        <b-navbar-nav class="mx-auto">
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item to="/about">Quem somos</b-nav-item>
          <b-nav-item-dropdown text="Software">
            <b-dropdown-item to="/software/hfs">HFS</b-dropdown-item>
            <b-dropdown-item to="/software/promax">Software de terceiros</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Fluxograma">
            <b-dropdown-item to="/fluxograma/controle-qualidade">
              Controle de qualidade
            </b-dropdown-item>
            <b-dropdown-item to="/fluxograma/processamento-2d-3d-tempo">
              Processamento 2D/3D em tempo
            </b-dropdown-item>
            <b-dropdown-item to="/fluxograma/processamento-2d-profundidade">
              Processamento 2D em profundidade
            </b-dropdown-item>
            <b-dropdown-item to="/fluxograma/produtos-entregaveis">
              Produtos entregáveis
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Produtos">
            <b-dropdown-item to="/products/1/correcao-estatica-tomografia">
              Processamento 2D em tempo
            </b-dropdown-item>
            <!-- <b-dropdown-item to="/products/2/analise-velocidade-tomografia">
              Processamento 2D em profundidade
            </b-dropdown-item> -->
            <!-- <b-dropdown-item to="/products/3/correcao-estatica-3d">
              Processamento 3D em tempo
            </b-dropdown-item> -->
            <!-- <b-dropdown-item href="#">
              Processamento 3D em profundidade
            </b-dropdown-item> -->
          </b-nav-item-dropdown>
          <b-nav-item to="/modelo-contratacao" class="pr-0">
            Modelo de contratação
          </b-nav-item>
          <b-nav-item-dropdown text="Privacidade">
            <b-dropdown-item to="/privacy/policy">Política de privacidade</b-dropdown-item>
            <b-dropdown-item to="/privacy/policy">Política de privacidade</b-dropdown-item>
            <b-dropdown-item to="/privacy/encarregado">Encarregado de dados</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style>
.navbar {
  font-weight: 600;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.15);
  color: #9597a6;
}

.nav-item {
  padding-right: 10px;
}

.dropdown-menu.show {
  box-shadow: 3px 5px 12px rgba(0, 0, 0, 0.15);
  border: none;
}

.dropdown-item {
  font-weight: 500;
  color: #9597a6;
}

.dropdown-item:hover {
  color: #f1c400;
}

.dropdown-item:active {
  background-color: #e0e0e0;
}
</style>
